import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import { motion } from "framer-motion";
import { useAuth } from "@/hooks/useAuth";
import { useLanguage } from "@/context/LanguageContext";
import { notFoundLabels } from "@/i18n";

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { language } = useLanguage();
  const labels = notFoundLabels(language);

  return (
    <DashboardLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4"
      >
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-4">{labels.title}</h2>
        <p className="text-muted-foreground mb-8 max-w-md">
          {labels.description}
        </p>
        <div className="flex gap-4">
          {user ? (
            <Button onClick={() => navigate("/dashboard")} variant="outline" size="lg">
              {labels.toDashboard}
            </Button>
          ) : (
            <Button onClick={() => navigate("/")} size="lg" className="gap-2">
              <Home className="w-5 h-5" />
              {labels.toStartPage}
            </Button>
          )}
        </div>
      </motion.div>
    </DashboardLayout>
  );
};

export default NotFound;
